import React from 'react';

interface WizardStepIndicatorProps {
    currentStep: number;
    hasPerTablerPosition: boolean;
}

const WizardStepIndicator: React.FC<WizardStepIndicatorProps> = ({
    currentStep,
    hasPerTablerPosition,
}) => {
    const steps = hasPerTablerPosition 
        ? ['Allgemein', 'Positionen', 'Mitgliederliste', 'Überprüfung']
        : ['Allgemein', 'Positionen', 'Überprüfung'];
    
    const stepNumbers = hasPerTablerPosition ? [1, 2, 3, 4] : [1, 2, 4];

    return (
        <div className="step-indicator">
            {steps.map((label, index) => (
                <div 
                    key={stepNumbers[index]} 
                    className={`step-item ${currentStep === stepNumbers[index] ? 'active' : ''} ${currentStep > stepNumbers[index] ? 'completed' : ''}`}
                >
                    <div className="step-number">{index + 1}</div>
                    <div className="step-label">{label}</div>
                </div>
            ))}
        </div>
    );
};

export default WizardStepIndicator;
